import { useMenus } from './useMenus'

export function useBrandSelectedPosition() {
	const { brandSelected, getTopBrands } = useMenus()

	const topBrands = getTopBrands()
	return topBrands.findIndex((brand) => brand.id === brandSelected)
}
